import service from './videoHttp';
var uuid = generateUUID();
// 获取内容
export const liveDemo = (userInput: string, language: string) =>
  service.request({
    method: 'post',
    url: '/admin/live/liveDemo',
    data: {
      token: 'live!Demo123',
      type: 1,
      text: userInput,
      topType: 2,
      voiceName: language,
    },
  });
export const gptCall = (userInput: string, language: string) =>
  service.request({
    method: 'post',
    url: '/admin/gpt/call',
    data: {
      question: userInput,
      uniId: uuid,
      voiceName: language,
    },
  });
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
